import {
    ALL_VOUCHER,
    DATA_UPDATED,
    VALIDATION_ERROR,
    SET_LOADING,
} from ".";

const initialState = {
    allVoucher: [],
    dataAdded: "",
    validationError: {},
    isLoading: false,
};

export default function voucherReducer(state = initialState, action) {
    switch (action.type) {
        case ALL_VOUCHER:
            return { ...state, allVoucher: action.payload };
        case DATA_UPDATED:
            return { ...state, dataAdded: action.payload };
        case VALIDATION_ERROR:
            return { ...state, validationError: action.payload };
        case SET_LOADING:
            return { ...state, isLoading: action.payload };
        default:
            return state;
    }
}